// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__Pxs4g","secondary":"Button_secondary__tzZ5o","tertiary":"Button_tertiary__ndnMZ"};